import $ from 'jquery';

class MenuSlider {

	constructor(element) {
		this.element = element;
		this.slider = null;

		this.update();
	}

	update() {
		this.init();
	}

	init() {
		if(this.slider === null && $(this.element).length > 0) {
			$(this.element).removeClass('d-none');
			this.slider = tns({
				container: this.element,
				items: 1,
				mouseDrag: true,
				// slideBy: 'page',
				loop: false,
				gutter: 30,
				controls: false,
				navPosition: 'bottom',
				nested: true,
				autoHeight: true,
				preventScrollOnTouch: 'auto',
				swipeAngle: false,
				// autoplay: true,
				// controlsContainer: ".controls",
				// navContainer: ".tns-nav",
				// autoplayButtonOutput: true
			});
		}
	}

	destroy() {
		if(this.slider !== null)  {
			this.slider.destroy();
			this.slider = null;
		}
		$(this.element).addClass('d-none');
	}
}

$(function () {

	let slider = null;
	let navSlider = null;

	function initSlider() {
		if(slider === null && $('.mobile-menu-main').length > 0) {
			slider = tns({
				container: '.mobile-menu-main',
				items: 1,
				gutter: 19,
				controls: false,
				touch: false,
				nav: false,
				autoHeight: true
			});
		}
	}

	function destroySlider() {
		if(slider !== null)  {
			slider.destroy();
			slider = null;
		}
	}

	function initNavMenu () {
		if (navSlider === null) {
			const $navContainer = $('.mobile-menu-slider-nav-container');

			let sections = [];
			$navContainer.html("");
			$('[data-section]').each((index, element) => {
				let activeClassName = index === 0 ? 'active':'';
				let section = element.dataset.section;
				if (sections.indexOf(section) > -1) return;
				sections.push(section);
				$navContainer.append(
					`<button data-index="${index}" class="menu-button ${activeClassName} mobile font-weight-bold text-uppercase">${section}</button>`
				);
			});

			if($navContainer.length) {
				navSlider = tns({
					container: '.mobile-menu-slider-nav-container',
					items: 1.7,
					mouseDrag: true,
					controls: false,
					slideBy: 1,
					center: true,
					navPosition: 'top',
					loop: false,
					preventScrollOnTouch: 'force',
					swipeAngle: 80,
					responsive: {
						400: {
							items: 3.2
						}
					}
				});
			}

			$navContainer.on('click','.menu-button', (evt) => {
				let index = evt.currentTarget.dataset.index;
				slider.goTo(index);
				$navContainer.find('.menu-button').removeClass('active');
				$(evt.currentTarget).addClass('active');
			});

		}
	}

	function destroyNavMenu () {
		if(navSlider !== null) {
			const $navContainer = $('.mobile-menu-slider-nav-container');
			navSlider.destroy();
			navSlider = null;
			$navContainer.off('click', '.menu-button');
		}
	}

	function main() {
		if(window.innerWidth < 992) {
			initNavMenu();
			initSlider();
		} else {
			destroySlider();
			destroyNavMenu();
		}
	}


	let sectionCount = {};
	$('[data-section]').each((index, element) => {
		let section = element.dataset.section;
		if(sectionCount[section] === undefined) sectionCount[section] = 1;
		else sectionCount[section]++;
	});

	for (let section in sectionCount) {
		if (Object.prototype.hasOwnProperty.call(sectionCount, section) && sectionCount[section] > 1) {
			let $group = $('[data-section="' + section + '"]');
			let first = $group[0];
			for(let i = 1; i < $group.length; i++) {
				let $item = $($group[i]);
				$item.children().clone().appendTo(first);
				$item.remove();
			}
		}
	}

	$('.js-slider-menu').each((index, element) => {
		new MenuSlider(element);
	});

	main();
	$(window).on('resize', (evt) => {
		main();
	});

});
